export function getSearchFromParams(params) {
  return params.get("search") || "";
}

export function buildSearchParams(params, value) {
  const nextParams = new URLSearchParams(params);
  const search = String(value || "");

  nextParams.delete("page");

  if (search.trim()) nextParams.set("search", search);
  else nextParams.delete("search");

  return nextParams;
}
